import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldIcon, UserIcon, CreditCardIcon, PhoneIcon } from '../../assets/icons';
import logo from '../../assets/logo.png';

const VERIFF_URL = 'https://www.veriff.com/';
const SUPPORT_EMAIL = 'hello@hansepay.com';

function EmailStartKycProcess() {
  return (
    <div className='min-h-screen bg-background flex items-center justify-center p-4'>
      <div className='w-full max-w-xl bg-card rounded-2xl shadow-lg overflow-hidden border border-border'>
        <div className='bg-primary px-8 py-10 flex flex-col items-center gap-3 rounded-t-2xl'>
          <img src={logo} alt='Atrya' className='h-10 object-contain brightness-0 invert' />
          <p className='text-primary-foreground/80 text-sm font-medium tracking-wide uppercase'>Identity Verification Required</p>
        </div>
        <div className='px-8 py-10 space-y-8'>
          <div className='text-center space-y-3'>
            <div className='mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-warning/10'>
              <ShieldIcon className='h-8 w-8 text-warning' aria-hidden />
            </div>
            <h1 className='text-2xl font-bold text-foreground'>Complete Your KYC Verification</h1>
            <p className='text-muted-foreground leading-relaxed max-w-md mx-auto'>
              To fully activate your Atrya account, we need to verify your identity. The process is quick, fully digital, and handled securely by our
              trusted partner{' '}
              <a href={VERIFF_URL} target='_blank' rel='noopener noreferrer' className='text-primary hover:underline font-medium'>
                Veriff
              </a>
              .
            </p>
          </div>
          <div className='space-y-3'>
            <p className='text-sm font-semibold text-foreground uppercase tracking-wide'>What to expect</p>
            <div className='space-y-2'>
              <div className='flex items-start gap-3 p-3.5 rounded-lg bg-muted/50'>
                <div className='flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/10'>
                  <UserIcon className='h-4 w-4 text-primary' aria-hidden />
                </div>
                <div>
                  <p className='text-sm font-medium text-foreground'>No person to speak to</p>
                  <p className='text-xs text-muted-foreground'>The process is entirely automated — no calls or video interviews required.</p>
                </div>
              </div>
              <div className='flex items-start gap-3 p-3.5 rounded-lg bg-muted/50'>
                <div className='flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/10'>
                  <CreditCardIcon className='h-4 w-4 text-primary' aria-hidden />
                </div>
                <div>
                  <p className='text-sm font-medium text-foreground'>Have your ID ready</p>
                  <p className='text-xs text-muted-foreground'>
                    You&apos;ll need a valid government-issued ID — passport, national ID, or driver&apos;s licence.
                  </p>
                </div>
              </div>
              <div className='flex items-start gap-3 p-3.5 rounded-lg bg-muted/50'>
                <div className='flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-primary/10'>
                  <PhoneIcon className='h-4 w-4 text-primary' />
                </div>
                <div>
                  <p className='text-sm font-medium text-foreground'>Keep your phone nearby</p>
                  <p className='text-xs text-muted-foreground'>A smartphone is required to complete the verification steps.</p>
                </div>
              </div>
            </div>
          </div>
          <div className='text-center'>
            <Link
              to='/verification-link-sent'
              className='inline-block bg-primary text-primary-foreground px-10 py-3.5 rounded-lg font-semibold text-base hover:opacity-90 transition-opacity shadow-sm'
            >
              Request verification
            </Link>
          </div>
          <div className='text-center pt-2'>
            <p className='text-xs text-muted-foreground leading-relaxed'>
              If you didn&apos;t create an account with Atrya, you can safely ignore this email.
              <br />
              Need help? Contact us at{' '}
              <a href={`mailto:${SUPPORT_EMAIL}`} className='text-primary hover:underline'>
                {SUPPORT_EMAIL}
              </a>
            </p>
          </div>
        </div>
        <div className='border-t bg-muted/30 px-8 py-5 text-center space-y-1'>
          <p className='text-xs text-muted-foreground'>© 2026 Atrya. All rights reserved.</p>
          <p className='text-xs text-muted-foreground'>This is an automated message — please do not reply directly.</p>
        </div>
      </div>
    </div>
  );
}

export default EmailStartKycProcess;
